<form [formGroup]="settingsForm" (ngSubmit)="submit()" [class.fake-hidden]="!showSettings">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'language-' + entity.id" class="col-sm-5 col-form-label">{{ 'COMMON.LANGUAGES.TITLE' | translate }}</label>
        <div class="col-sm-7">
          <select class="form-select" [id]="'language' + entity.id" formControlName="language">
            <option *ngFor="let language of utils.languages_360" [value]="language.value">{{('COMMON.LANGUAGES.' + language.name) |translate}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-4" *ngIf="entity.entityTypeId !== 4">
    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">App Frontend Design</h4>

      <div class="row mb-3">
        <label [for]="'360AppName-' + entity.id" class="col-sm-5 col-form-label">360Depict App Name</label>
        <div class="col-sm-7">
          <input type="text" class="form-control border-0 rounded-0" [id]="'360AppName' + entity.id" formControlName="360AppName">
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'logoC-' + entity.id" class="col-sm-5 col-form-label">360Depict Logo (C)
          <hbo-field-info-icon fieldName="depict360Logo"></hbo-field-info-icon>
          <a *ngIf="currentSettings?.appFrontendDesign?.['360Depict']?.logoImage && !settingsForm.disabled" (click)="clearImage($event, 'logoC-' + entity.id)"class="clear-pb"><i class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings?.appFrontendDesign?.['360Depict']?.logoImage" class="cursor-pointer image-link" [ngClass]="{'only-image-link':settingsForm.disabled}" (click)="showImage($event, currentSettings?.appFrontendDesign?.['360Depict']?.logoImage)">
            <i class="bi bi-image"></i>
          </a>
      </label>
        <div class="col-sm-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <!-- <label class="input-group-text cursor-pointer rounded-0" [for]="'logoC-' + entity.id">Browse</label> -->
            <label class="label-input-file" [for]="'logoC-' + entity.id">
                <div>
                  <div class="label-input-file-placeholder">
                      {{
                        currentSettings?.appFrontendDesign?.['360Depict']?.logoImage &&
                        currentSettings?.appFrontendDesign?.['360Depict']?.logoName
                          ? currentSettings?.appFrontendDesign?.['360Depict']?.logoName
                          : ('COMMON.UPLOADIMAGE' | translate)
                      }}
                  </div>
                  <div class="label-input-file-browse">Browse</div>
                </div>
            </label>
            <input type="file" class="form-control" [class]="settingsForm.controls.logoC.value? 'input-file-filled': 'input-file-empty'" (change)="uploadFile($event,'logoC')" [id]="'logoC-' + entity.id" formControlName="logoC">
          </div>
          <hbo-field-validation fieldName="logoC"></hbo-field-validation>
        </div>
      </div>
    </div>

    <div class="col-5 offset-1">
      <div class="mt-4 preview">
        <object data="assets/images/preview/360.png" [id]="'layoutThumbnail' + entity.id"></object>
        <button type="button" class="btn btn-outline-dark mt-2" (click)="preview()"><i class="bi bi-eye"></i> Preview</button>
      </div>
    </div>
  </div>

  <div class="row p-4" *ngIf="entity.entityTypeId !== 3 && entity.entityTypeId !== 4 ">
    <div class="col-12">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Technologies</h4>
      <div formGroupName="technologies">
        <div class="row py-2" *ngIf="user.roleId === 1 || (user.roleId !== 1 && settingsForm.get('technologies.thinmaxPositive')?.value)">
          <div class="col-3 d-flex align-content-center flex-wrap">
            <label [for]="'thinmaxPositive-' + entity.id">Thinmax positive</label>
          </div>
          <div class="col-5">
            <input *ngIf="user.roleId === 1" class="align-middle m-0 form-check-input" type="checkbox" [id]="'thinmaxPositive' + entity.id" formControlName="thinmaxPositive">
            <input type="text" class="form-control border-0 rounded-0 d-inline-block w-75 ms-3" [id]="'appName' + entity.id" formControlName="thinmaxPositiveName">
          </div>
        </div>
        <div class="row py-2" *ngIf="user.roleId === 1 || (user.roleId !== 1 && settingsForm.get('technologies.thinmaxNegative')?.value)">
          <div class="col-3 d-flex align-content-center flex-wrap">
            <label [for]="'thinmaxNegative-' + entity.id">Thinmax negative</label>
          </div>
          <div class="col-5">
            <input *ngIf="user.roleId === 1" class="align-middle m-0 form-check-input" type="checkbox" [id]="'thinmaxNegative' + entity.id" formControlName="thinmaxNegative">
            <input type="text" class="form-control border-0 rounded-0 d-inline-block w-75 ms-3" [id]="'appName' + entity.id" formControlName="thinmaxNegativeName">
          </div>
        </div>
        <div class="row py-2" *ngIf="user.roleId === 1 || (user.roleId !== 1 && settingsForm.get('technologies.highPrescriptions')?.value)">
          <div class="col-3 d-flex align-content-center flex-wrap">
            <label [for]="'highPrescriptions-' + entity.id">High Prescriptions</label>
          </div>
          <div class="col-5">
            <input *ngIf="user.roleId === 1" class="align-middle m-0 form-check-input" type="checkbox" [id]="'highPrescriptions' + entity.id" formControlName="highPrescriptions">
            <input type="text" class="form-control border-0 rounded-0 d-inline-block w-75 ms-3" [id]="'appName' + entity.id" formControlName="highPrescriptionsName">
          </div>
        </div>
        <div class="row py-2" *ngIf="user.roleId === 1 || (user.roleId !== 1 && settingsForm.get('technologies.extremePrescriptions')?.value)">
          <div class="col-3 d-flex align-content-center flex-wrap">
            <label [for]="'extremePrescriptions-' + entity.id">Extreme Prescriptions</label>
          </div>
          <div class="col-5">
            <input *ngIf="user.roleId === 1" class="align-middle m-0 form-check-input" type="checkbox" [id]="'extremePrescriptions' + entity.id" formControlName="extremePrescriptions">
            <input type="text" class="form-control border-0 rounded-0 d-inline-block w-75 ms-3" [id]="'appName' + entity.id" formControlName="extremePrescriptionsName">
          </div>
        </div>
        <div class="row py-2" *ngIf="user.roleId === 1 || (user.roleId !== 1 && settingsForm.get('technologies.curvedStyle')?.value)">
          <div class="col-3 d-flex align-content-center flex-wrap">
            <label [for]="'curvedStyle-' + entity.id">Curved style</label>
          </div>
          <div class="col-5">
            <input *ngIf="user.roleId === 1" class="align-middle m-0 form-check-input" type="checkbox" [id]="'curvedStyle' + entity.id" formControlName="curvedStyle">
            <input type="text" class="form-control border-0 rounded-0 d-inline-block w-75 ms-3" [id]="'appName' + entity.id" formControlName="curvedStyleName">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="user.profileId !== 2 && !(entity.id === user.entityId && user.profileId !== 3 && !(user.roleId === 4 && user.profileId === 1))">
    <button type="button" class="btn btn-outline-secondary me-2">Cancel</button>
    <button type="submit" class="btn btn-dark">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
  </div>
</form>

  <hbo-preview-external-settings #externalSettings></hbo-preview-external-settings>
